import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Notes service is now integrated with hscan-application-service. Run application service locally on port 6076 and uncomment out below to run notes locally
// Uncomment this to test localhost
// envUrls.notesService = 'http://localhost:6076/notes/';

export default class NoteService {
  async addNote(payload) {
    return await axiosInstance
      .post(`${envUrls.notesService}add`, payload)
      .then((response) => {
        return response.data;
      });
  }

  async getNotes(payload) {
    return await axiosInstance
      .get(
        `${envUrls.notesService}get_by_scan/${payload.scan_id}/${payload.user_id}`
      )
      .then((response) => {
        return response.data;
      });
  }

  async getNoteCountsByScan(payload) {
    return await axiosInstance
      .get(`${envUrls.notesService}get_counts_by_scan/${payload.user_id}`)
      .then((response) => {
        return response.data;
      });
  }

  async getSharedNotes(payload) {
    return await axiosInstance
      .get(
        `${envUrls.notesService}get_by_scan_shared/${payload.scan_id}/${payload.user_id}`
      )
      .then((response) => {
        return response.data;
      });
  }

  async deleteNote(payload) {
    return await axiosInstance
      .delete(`${envUrls.notesService}delete/${payload}`)
      .then((response) => {
        return response.data;
      });
  }

  async deleteAllNotesByScan(payload) {
    return await axiosInstance
      .delete(`${envUrls.notesService}delete_by_scan/${payload.scan_id}`)
      .then((response) => {
        return response.data;
      });
  }

  async deleteUserNotesByScan(payload) {
    return await axiosInstance
      .delete(
        `${envUrls.notesService}delete_user_notes_by_scan/${payload.scan_id}/${payload.user_id}`
      )
      .then((response) => {
        return response.data;
      });
  }

  async updateNote(id, payload) {
    return await axiosInstance
      .patch(`${envUrls.notesService}edit/${id}`, payload)
      .then((response) => {
        return response.data;
      });
  }
}
